import router from '@/router';
import { resetStores, resetTenantSpecificStores } from '@/stores';
import { useAuthStore } from '@stores/auth-store';
import { useToastStore } from '@stores/toast-store';
import { useViewStateStore } from '@stores/view-state-store';
import { apiRevokeTokenPair } from '@api/v1/requests';
import { ENTRY_POINTS } from '@constants/entry-points';

export const useExitTenant = () => {
  const exitTenant = async ({
    propagateError = false,
  }: {
    propagateError?: boolean;
  } = {}) => {
    const toastStore = useToastStore();

    try {
      await resetTenantSpecificStores();
      await router.push(ENTRY_POINTS.PATH.USER_HOME());
      await toastStore.notify('Exited workspace.');
    } catch (error) {
      console.error(error);
      toastStore.warn('Failed to exist workspace.');
      if (propagateError) {
        throw error;
      }
    }
  };

  return {
    exitTenant,
  };
};

export const useLogout = () => {
  const logout = async ({
    propagateError = false,
    redirect = true,
  }: {
    propagateError?: boolean;
    redirect?: boolean;
  } = {}) => {
    const toastStore = useToastStore();
    const authStore = useAuthStore();
    const viewStateStore = useViewStateStore();

    const { refresh } = authStore;

    try {
      if (refresh) {
        const payload = await {
          refresh,
        };
        await apiRevokeTokenPair({ payload });
        await toastStore.notify('You have been logged out');
      }

      await resetStores();

      if (redirect) {
        await router.push(ENTRY_POINTS.PATH.LOGIN_TOP());
      }
    } catch (error) {
      console.error(error);
      toastStore.warn('Failed to log out');
      viewStateStore.stopRequesting();
      if (propagateError) {
        throw error;
      }
    }
  };

  const softLogout = async ({
    propagateError = false,
  }: {
    propagateError?: boolean;
  } = {}) => {
    await logout({ propagateError, redirect: false });
  };

  return {
    logout,
    softLogout,
  };
};
